import { Navigate, useLocation } from 'react-router-dom'
import { useAuthStore } from '../services/authStore'

export default function ProtectedRoute({ children }) {
  const location = useLocation()
  const { isAuthenticated, isInitializing, legalRequiredDocs, legalGateChecked } = useAuthStore()
  const isLegalAcceptanceRoute = location.pathname === '/legal/acceptance'
  const hasRequiredLegalDocs = Array.isArray(legalRequiredDocs) && legalRequiredDocs.length > 0

  if (isInitializing) {
    return null
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  if (!legalGateChecked) {
    return null
  }

  if (hasRequiredLegalDocs && !isLegalAcceptanceRoute) {
    return <Navigate to="/legal/acceptance" replace state={{ from: location }} />
  }

  if (!hasRequiredLegalDocs && isLegalAcceptanceRoute) {
    return <Navigate to="/" replace />
  }

  return children
}
